/*
 * @Description: 排号管理 查看排号模板
 * @Author: ma.cq
 * @Date: 2018-10-23 19:42:05
 * @LastEditors: ma.cq
 * @LastEditTime: 2018-10-23 20:31:50
 */
<template>
  <el-dialog title="重新排号" :visible.sync="visible" @close="handleClose" width="800px">
    <el-form class="form" :model="form" ref="form" label-width="120px">
      <el-form-item label="放号日期">
        {{listInfo.date}}
      </el-form-item>
      <el-form-item label="放号时段">
        {{form.releaseNumType === 1 ? '全天放号' : '自定义时段'}}
      </el-form-item>
      <el-form-item class="four-part-box" label="放号数量">
        <el-form-item v-if="form.releaseNumType === 1" prop="maxNum">
          <el-input-number
            v-model="form.maxNum"
            controls-position="right"
            :min="0"
            :precision="0">
          </el-input-number>
        </el-form-item>
        <template v-else-if="form.releaseNumType === 3">
          <el-row v-for="(item, index) of form.times" :key="index">
            <el-col class="times" :span="12">
              <el-form-item :prop="`times[${index}].startTime`" :rules="rules.startTime">
                <el-time-select
                  placeholder="开始时间"
                  v-model="item.startTime"
                  class="time-select-width"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '23:59'
                  }"></el-time-select>
              </el-form-item>
              至
              <el-form-item :prop="`times[${index}].endTime`" :rules="rules.endTime">
                <el-time-select
                  placeholder="结束时间"
                  v-model="item.endTime"
                  class="time-select-width"
                  :picker-options="{
                    start: '00:00',
                    step: '00:01',
                    end: '23:59'
                  }"></el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :prop="`times[${index}].num`" :rules="rules.num">
                <el-input-number
                  v-model="item.num"
                  controls-position="right"
                  :min="0"
                  :precision="0"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="index === 0">
              <el-button @click="addTime">+</el-button>
            </el-col>
            <el-col :span="2" v-if="index !== 0">
              <el-button @click="delTime(index)" :disabled="item.appointed">-</el-button>
            </el-col>
            <el-col v-if="item.orderNum !== ''" :span="3">
              已预约：{{item.orderNum}}人
            </el-col>
          </el-row>
        </template>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave">保存</el-button>
      <el-button type="primary" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'checkDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    listInfo: {
      type: Object
    }
  },
  data () {
    return {
      visible: this.show,
      form: {
        releaseNumType: '',
        maxNum: '',
        times: [{
          startTime: '',
          endTime: '',
          num: '',
          orderNum: ''
        }],
        delTimeIds: []
      },
      rules: {
        releaseNumType: [{ required: true, message: '请选择放号时段类型' }],
        maxNum: [{ required: true, message: '请输入放号数量' }],
        startTime: [{ required: true, message: '请选择开始时间' }],
        endTime: [{ required: true, message: '请选择结束时间' }],
        num: [{ required: true, message: '请输入放号数量' }]
      },
      templateId: '',
      detailId: '',
      allTimeId: ''
    }
  },
  methods: {
    ...mapActions(['appointDetail', 'appointUpdateTemplate', 'appointNumMouldList']),
    handleClose () {
      this.$emit('update:show', false)
    },
    addTime () {
      this.form.times.push({
        startTime: '',
        endTime: '',
        num: '',
        id: '',
        orderNum: '',
        appointed: false
      })
    },
    delTime (index) {
      const delId = this.form.times[index].id
      if (delId) {
        this.form.delTimeIds.push(delId)
      }
      this.form.times.splice(index, 1)
    },
    valiTimes () {
      const arr = this.form.times
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        if (item.startTime >= item.endTime) {
          this.$message.warning('结束时间要晚于开始时间')
          return false
        }
        if (i > 0) {
          const lastItem = arr[i - 1]
          if (item.startTime <= lastItem.endTime) {
            this.$message.warning('开始时间要晚于上一阶段结束时间')
            return false
          }
        }
      }
      return true
    },
    handleSave () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.releaseNumType === 3 && !this.valiTimes()) {
            return
          }
          //
          let arr = []
          if (this.form.releaseNumType === 1) {
            if (this.form.maxNum < this.listInfo.orderCount) {
              this.$message.error('修改余号数量不能小于已预约人数!')
              return
            }
            arr = [{
              onlineMaxCount: this.form.maxNum,
              type: 0,
              id: this.allTimeId
            }]
          } else {
            for (let i = 0; i < this.form.times.length; i++) {
              const item = this.form.times[i]
              if (item.num < item.orderNum) {
                this.$message.error('修改余号数量不能小于已预约人数!')
                return
              }
              arr.push({
                customTime: [item.startTime, item.endTime],
                onlineMaxCount: item.num,
                type: 13,
                id: item.id
              })
            }
          }
          let params = {
            releaseNumType: this.form.releaseNumType,
            templateId: this.templateId,
            bookingNumberFragmentDetails: arr,
            id: this.detailId,
            delRangeNumDetailId: this.form.delTimeIds
          }
          this.appointUpdateTemplate(params).then(() => { // manage/delivery/booking/number/update
            this.appointNumMouldList(this.info).then(res => {
              this.$emit('childByValue', res)
            })
            this.$emit('update:show', false)
          })
        } else {
          return false
        }
      })
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      // 显示dialog时给form赋初始值
      if (newVal) {
        this.appointDetail({ id: this.id }).then(res => {
          const initForm = {
            releaseNumType: res.releaseNumType,
            maxNum: '',
            times: [{
              startTime: '',
              endTime: '',
              num: '',
              id: '',
              orderNum: '',
              appointed: false
            }],
            delTimeIds: []
          }
          if (res.releaseNumType === 1) {
            initForm.maxNum = res.bookingNumberFragmentDetails[0].onlineMaxCount
            this.allTimeId = res.bookingNumberFragmentDetails[0].id
          } else if (res.releaseNumType === 3) {
            initForm.times = res.bookingNumberFragmentDetails.map(item => {
              return {
                startTime: item.customTime[0],
                endTime: item.customTime[1],
                num: item.onlineMaxCount,
                id: item.id,
                orderNum: item.orderNum,
                appointed: !!res.isAppointment
              }
            })
          }
          this.form = { ...initForm }
          this.templateId = res.templateId
          this.detailId = res.id
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form{
  margin: 0 auto;
  max-width: 780px;
}
.form-input-inline{
  width: 140px;
}
.marLeft10{
  margin-left: 10px;
}
.marTop10{
  margin-top: 10px;
}
.four-part-box{
  .el-row:not(:last-child){
    margin-bottom: 10px;
  }
}
.time-select-width{
  width: 135px;
}
.times {
  display: flex;
  justify-content: space-between;
  margin-right: 10px;
}
</style>
